module.exports = __webpack_public_path__ + "img/featured-2.cbcda3d2.png";